import { logger } from '@common/logger';

declare global {
    interface Window {
        __STORYBOOK_PREVIEW__: any;
    }
}

/**
 * whether to skip storybook
 */
export const shouldSkipStorybook = (reason?: string): boolean => {
    const isStorybook = typeof window === 'object' && window?.__STORYBOOK_PREVIEW__;

    if (isStorybook && reason) {
        logger.trace(reason);
    }

    return isStorybook;
};
